import { makeAutoObservable } from 'mobx';
import { Seller } from '../../models/Seller';
import { SellerApi } from '../../apis/Seller';
import { message } from 'antd';

type SortByType = 'registerTime' | 'level' | 'consultCount' | 'orderCount' | 'grossConversionRate' | 'netConversionRate' | 'deposit' | 'unwithdrawAmount';

export class SellerManagementPageModel {
    sellers: Seller[] = [];
    loading = false;
    selectedSeller: Seller | null = null;
    showDetailModal = false;
    showBlacklistModal = false;

    // 筛选条件
    keyword = '';
    deposit: 'all' | 'full' | 'partial' | 'none' = 'all';
    isVerified: 'all' | 'yes' | 'no' = 'all';
    isSuperIndividual: 'all' | 'yes' | 'no' = 'all';
    sortBy: SortByType = 'registerTime';
    sortOrder: 'asc' | 'desc' = 'desc';

    constructor() {
        makeAutoObservable(this);
    }

    setKeyword = (keyword: string) => {
        this.keyword = keyword;
    }

    setDeposit = (deposit: 'all' | 'full' | 'partial' | 'none') => {
        this.deposit = deposit;
    }

    setIsVerified = (isVerified: 'all' | 'yes' | 'no') => {
        this.isVerified = isVerified;
    }

    setIsSuperIndividual = (isSuperIndividual: 'all' | 'yes' | 'no') => {
        this.isSuperIndividual = isSuperIndividual;
    }

    setSortBy = (sortBy: SortByType) => {
        if (this.sortBy === sortBy) {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortBy = sortBy;
            this.sortOrder = 'desc';
        }
    }

    setSelectedSeller = (seller: Seller | null) => {
        this.selectedSeller = seller;
        this.showDetailModal = !!seller;
    }

    setShowBlacklistModal = (show: boolean) => {
        this.showBlacklistModal = show;
    }

    loadSellers = async () => {
        this.loading = true;
        try {
            const sellers = await SellerApi.getSellerList({
                keyword: this.keyword || undefined,
                deposit: this.deposit === 'all' ? undefined : this.deposit,
                isVerified: this.isVerified === 'all' ? undefined : this.isVerified,
                isSuperIndividual: this.isSuperIndividual === 'all' ? undefined : this.isSuperIndividual,
                sortBy: this.sortBy,
                sortOrder: this.sortOrder,
                page: 1,
                pageSize: 20
            });
            this.sellers = sellers;
        } catch (error) {
            message.error('加载卖家列表失败');
        } finally {
            this.loading = false;
        }
    }

    // 新增：重置筛选与排序，并刷新列表
    resetFilters = async () => {
        this.keyword = '';
        this.deposit = 'all';
        this.isVerified = 'all';
        this.isSuperIndividual = 'all';
        this.sortBy = 'registerTime';
        this.sortOrder = 'desc';
        await this.loadSellers();
    }

    updateSuperIndividualStatus = async (sellerId: string, isSuperIndividual: 0 | 1) => {
        try {
            const success = await SellerApi.updateSuperIndividual({ sellerId, isSuperIndividual });
            if (success) {
                message.success('更新超级个体状态成功');
                await this.loadSellers();
            } else {
                message.error('更新超级个体状态失败');
            }
        } catch (error) {
            message.error('更新超级个体状态失败');
        }
    }

    updateBlacklistStatus = async (sellerId: string, type: 0 | 1, reason: string) => {
        try {
            const success = await SellerApi.updateBlacklist({ sellerId, type, reason });
            if (success) {
                message.success(type === 0 ? '拉黑成功' : '取消拉黑成功');
                await this.loadSellers();
            } else {
                message.error(type === 0 ? '拉黑失败' : '取消拉黑失败');
            }
        } catch (error) {
            message.error(type === 0 ? '拉黑失败' : '取消拉黑失败');
        }
    }
} 